import type { TFunction } from "i18next";

/**
 * Libellé d'une colonne `biens` pour la page de synchronisation Immoweb :
 * clé dédiée `v2.immowebSync.fields.*`, sinon les libellés déjà existants des
 * fiches (`vente.fields.*`, `biens.*`). Couverture des trois langues vérifiée
 * par `immowebSyncLabels.test.ts`.
 */
export function fieldLabel(t: TFunction, field: string): string {
  return t([`v2.immowebSync.fields.${field}`, `vente.fields.${field}`, `biens.${field}`], {
    defaultValue: field,
  });
}
